<template>
  <Skeleton width="100%" height="1.5rem" class=""></Skeleton>
  <Skeleton width="100%" height="2.6rem" class="mt-1"></Skeleton>
</template>
<script>
import Skeleton from 'primevue/skeleton'

export default {
  name: 'FieldSkeleton',
  components: { Skeleton }
}
</script>
